import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static values = { defaultTab: String };

  connect() {
    const hash = window.location.hash.substring(1);
    if (hash && this.tabTargets.some(tab => tab.dataset.tabName === hash)) {
      this.activeTabValue = hash;
    } else {
      this.activeTabValue = this.defaultTabValue || this.tabTargets[0].dataset.tabName;
    }
    this.updateUI();
  }

  switch(event) {
    event.preventDefault();
    this.activeTabValue = event.currentTarget.dataset.tabName;
    this.updateUI();
    
    // Update URL hash without jumping
    const url = new URL(window.location);
    url.hash = this.activeTabValue;
    window.history.replaceState({}, "", url);
  }

  updateUI() {
    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tabName === this.activeTabValue;
      tab.classList.toggle("border-gray-900", active);
      tab.classList.toggle("dark:border-gray-100", active);
      tab.classList.toggle("text-gray-900", active);
      tab.classList.toggle("dark:text-white", active);
      tab.classList.toggle("border-transparent", !active);
      tab.classList.toggle("text-gray-500", !active);
      tab.classList.toggle("dark:text-gray-400", !active);
    });

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabName !== this.activeTabValue);
    });
  }
}
